import type { ReactNode } from "react";
import {
    CheckIcon as Check,
    PlusIcon as Plus,
} from "@wags/ui/product-icons.tsx";
import type { ListingContactGap } from "./listing-contact-help.contract";
import type { ListingFactRow } from "./use-listing-contact-help";

export function ListingContactFacts({
    rows,
    selected,
    onToggle,
    children,
}: {
    rows: readonly ListingFactRow[];
    selected: readonly ListingContactGap[];
    onToggle: (gap: ListingContactGap) => void;
    children: ReactNode;
}) {
    return (
        <section className="rounded-card border border-doberman-black/10 p-card text-left text-doberman-black">
            <h2 className="sr-only">At a glance</h2>
            <dl className="flex flex-col">
                {rows.map((row) => {
                    const on =
                        row.gap !== undefined && selected.includes(row.gap);
                    const Icon = on ? Check : Plus;
                    return (
                        <div
                            key={row.label}
                            className="flex min-h-11 flex-wrap items-center justify-between gap-x-3 gap-y-1 border-t border-doberman-black/10 py-2 first:border-t-0 first:pt-0"
                        >
                            <dt className="min-w-0 text-body text-doberman-black/55 text-pretty break-words">
                                {row.label}
                            </dt>
                            {row.gap === undefined ? (
                                <dd className="text-right text-body font-semibold text-pretty break-words">
                                    {row.value}
                                </dd>
                            ) : (
                                <dd className="ml-auto flex shrink-0 items-center gap-2">
                                    <span
                                        aria-hidden
                                        className="text-body-small text-doberman-black/45"
                                    >
                                        Not listed
                                    </span>
                                    <button
                                        type="button"
                                        aria-pressed={on}
                                        aria-label={`Ask: ${row.question}`}
                                        onClick={() => onToggle(row.gap)}
                                        className="relative inline-flex h-7 items-center gap-1 rounded-full border border-dashed border-doberman-black/30 pr-2.5 pl-2 text-body-small font-medium text-doberman-black/80 transition-[border-color,background-color,color,transform] duration-150 ease-out before:absolute before:-inset-x-1 before:-inset-y-2 active:scale-[0.97] aria-pressed:border-solid aria-pressed:border-doberman-black aria-pressed:bg-doberman-black aria-pressed:text-true-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-labrador-yellow motion-reduce:transition-none [@media(hover:hover)]:hover:border-doberman-black/60"
                                    >
                                        <Icon
                                            aria-hidden
                                            className="size-3.5 shrink-0"
                                        />
                                        {on ? "Asking" : "Ask"}
                                    </button>
                                </dd>
                            )}
                        </div>
                    );
                })}
            </dl>
            <div className="mt-4">{children}</div>
        </section>
    );
}
